var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubject(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-subject"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "subject",
    clipPath: "url(#clip-subject)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-book-open",
    "data-name": "Icon awesome-book-open",
    d: "M458.447,2.309C412.114,5.689,320.022,17.995,263.171,62.738c-3.923,3.087-6.147,8.577-6.147,14.316V472.6c0,12.555,10.679,20.491,19.683,14.664,58.492-37.851,143.084-48.178,184.911-51C475.9,435.291,487,420.572,487,402.93V35.681c.008-19.252-12.978-34.5-28.553-33.372ZM223.829,62.738C166.986,17.995,74.894,5.7,28.561,2.309,12.987,1.178,0,16.429,0,35.681V402.94c0,17.654,11.1,32.372,25.382,33.329,41.844,2.826,126.478,13.164,184.97,51.037,8.979,5.816,19.624-2.109,19.624-14.632V76.858C229.976,71.108,227.761,65.836,223.829,62.738Z",
    transform: "translate(12.5 10.25)",
    fill: "#b44677"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubject);
export default __webpack_public_path__ + "static/media/subject.886aae87.svg";
export { ForwardRef as ReactComponent };